import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, tap } from 'rxjs/operators';

import { EMPTY_STRING } from '@shared/models/strings.constants';
import { DefaultSelectionValue, FormGroupValue, InputProps } from '../input-props';

@UntilDestroy()
@Component({
  selector: 'miq-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  styles: [
    `
      .multiselect-clear {
        position: absolute;
        top: 10px;
        right: 34px;
        font-size: 19px;
        cursor: pointer;
      }
    `,
  ],
  standalone: false,
})
export class SearchBarComponent<T = DefaultSelectionValue> implements OnInit, OnDestroy {
  @Input() props: InputProps<T>;
  @Input() set searchValue(valueToSearch: DefaultSelectionValue) {
    this._searchValue = valueToSearch != null ? valueToSearch.toString() : '';
  }

  @Output() search = new EventEmitter<FormGroupValue<T> | string>();

  private prevText = EMPTY_STRING;

  control = new UntypedFormControl();
  private _searchValue: string;

  ngOnInit() {
    this.control.setValue(this._searchValue);
    this.control.valueChanges
      .pipe(
        untilDestroyed(this),
        debounceTime(300),
        filter(
          // emit if trimmed text bigger than 3 OR if is empty after a valid prev search (reset)
          text => text != null && (text.trim().length >= 3 || (this.prevText !== EMPTY_STRING && text.length === 0))
        ),
        tap(text => (this.prevText = text))
      )
      .subscribe(value =>
        this.props && this.props.field ? this.search.emit({ [this.props.field]: value }) : this.search.emit(value)
      );
  }

  clearFilter() {
    this.control.setValue(null);
    this.search.emit(this.props?.field ? { [this.props.field]: null } : null);
  }

  ngOnDestroy() {
    /* REQUIRED by untilDestroyed */
  }
}
